import { render, staticRenderFns } from "./AbsentLetterFooter.vue?vue&type=template&id=775ed6ed&scoped=true"
import script from "./AbsentLetterFooter.vue?vue&type=script&lang=js"
export * from "./AbsentLetterFooter.vue?vue&type=script&lang=js"
import style0 from "./AbsentLetterFooter.vue?vue&type=style&index=0&id=775ed6ed&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ed6ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775ed6ed')) {
      api.createRecord('775ed6ed', component.options)
    } else {
      api.reload('775ed6ed', component.options)
    }
    module.hot.accept("./AbsentLetterFooter.vue?vue&type=template&id=775ed6ed&scoped=true", function () {
      api.rerender('775ed6ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/absent_letter_v3/components/AbsentLetterFooter.vue"
export default component.exports